import PropTypes from "prop-types";
import { useState, useEffect } from "react";
import { LineChart } from "@2solve/tosolve-charts";
import { Spinner } from "react-bootstrap";
import * as IconsImgs from "@2solve/tosolve-icons/dist/icons";
import { t } from "i18next";

export const CHART_COLORS = [
  { surface: "#006d00", downhole: "#0a0045" },
  { surface: "#00DB00", downhole: "#006ce5" },
  { surface: "#e67e22", downhole: "#c0392b" },
  { surface: "#9b59b6", downhole: "#1abc9c" },
  { surface: "#f39c12", downhole: "#e91e63" },
  { surface: "#00bcd4", downhole: "#ff5722" },
  { surface: "#8bc34a", downhole: "#673ab7" },
  { surface: "#ff9800", downhole: "#009688" },
];

const DynamometricChart = ({ data }) => {
  const [chartData, setChartData] = useState({ datasets: [] });
  const [chartOptions, setChartOptions] = useState({});
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!data || data.length === 0) return;

    const datasets = (Array.isArray(data) ? data : []).flatMap(
      (chartData, index) => {
        if (!chartData?.surface_card && !chartData?.downhole_card) return [];

        const colors = CHART_COLORS[index % CHART_COLORS.length];
        const result = [];

        if (chartData?.surface_card) {
          const surfacePoints = chartData.surface_card.position.map(
            (pos, i) => ({ x: pos, y: chartData.surface_card.load[i] }),
          );
          result.push({
            label: `${t("Carta de superfície")} ${index + 1}`,
            data: surfacePoints,
            borderColor: colors.surface,
            backgroundColor: colors.surface,
            fill: false,
            pointRadius: 0,
          });
        }

        if (chartData?.downhole_card) {
          const downholePoints = chartData.downhole_card.position.map(
            (pos, i) => ({ x: pos, y: chartData.downhole_card.load[i] }),
          );
          result.push({
            label: `${t("Carta de fundo")} ${index + 1}`,
            data: downholePoints,
            borderColor: colors.downhole,
            backgroundColor: colors.downhole,
            fill: false,
            pointRadius: 0,
          });
        }

        return result;
      },
    );

    setChartData({ datasets });

    setChartOptions({
      plugins: {
        legend: {
          onClick: () => {},
        },
      },
      scales: {
        x: {
          type: "linear",
          title: { display: true, text: t("Posição") },
        },
        y: {
          type: "linear",
          title: { display: true, text: t("Força") },
        },
      },
      interaction: { mode: "nearest", axis: "xy", intersect: false },
    });

    setLoading(false);
  }, [data]);

  return loading ? (
    <Spinner animation="border" size="sm" />
  ) : (
    <LineChart
      data={chartData}
      options={chartOptions}
      enableZoom={false}
      enableDoubleClickResetZoom={false}
      height="100%"
      enableExport={true}
      iconDownload={IconsImgs.MiniDownload}
    />
  );
};

const cardShape = PropTypes.shape({
  position: PropTypes.arrayOf(PropTypes.number).isRequired,
  load: PropTypes.arrayOf(PropTypes.number).isRequired,
});

DynamometricChart.propTypes = {
  data: PropTypes.arrayOf(
    PropTypes.shape({
      surface_card: cardShape.isRequired,
      downhole_card: cardShape.isRequired,
    }),
  ).isRequired,
};

export default DynamometricChart;
